import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { Grid, Button, Box, Typography, TextField, LinearProgress } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Autocomplete from '@mui/material/Autocomplete';
import { createFilterOptions } from "@mui/material/Autocomplete";
import { ToastContainer, toast } from 'react-toastify';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import InfoIcon from '@mui/icons-material/Info';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
const MySwal = withReactContent(Swal);

const showDuplicateEntryAlert = () => {
    MySwal.fire({
        title: <strong>Qty Mismatch..!</strong>,
        html: <p>Qty mismatching in BatchNo Qty.<br /> Please check your entries.</p>,
        icon: 'info',
        confirmButtonColor: '#1976d2', // Change this color as needed
        confirmButtonText: 'OK',
    });
};

const LoadingOverlay = ({ loading }) => {
    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'rgba(0, 0, 0, 0.8)', // Dark translucent background
            }}
            open={loading}
        >
            <Box sx={{ textAlign: 'center' }}>
                <CircularProgress
                    color="secondary"
                    size={62}
                    thickness={4}
                    sx={{ mb: 2 }} // Add some spacing below the spinner
                />
                <Typography
                    variant="h5"
                    sx={{
                        fontWeight: 'bold',
                        color: '#ffeb3b', // Bright yellow text
                        animation: 'fade 2s infinite',
                    }}
                >
                    Loading, please wait...
                </Typography>
            </Box>
            <style>
                {`
                @keyframes fade {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.5; }
                }
                `}
            </style>
        </Backdrop>
    );
};

function ProductionEntry(props) {
    const navigate = useNavigate();
    const [FormulaNo, setFormulaNo] = useState(0);
    const [EntryNo, setEntryNo] = useState(0);
    const [TrDate, setTrDate] = useState(getCurrentDate());
    const [FinishedItCode, setFinishedItCode] = useState(0);
    const [PerQty, setPerQty] = useState(0.0);
    const [shortQty, setShortQty] = useState(0.0);
    const [Rate, setRate] = useState(0);
    const [Loss, setLoss] = useState(0);
    const [Amount, setAmount] = useState(0);
    const [ProdPlanNo, setProdPlanNo] = useState(0);
    const [BatchNo, setBatchNo] = useState(0);
    const [FormPerQty, setFormPerQty] = useState(0);
    const [EmpCode, setEmpCode] = useState('');
    const [Narration, setNarration] = useState('');
    const [loading, setLoading] = useState(false);

    const [opbal, setOpbal] = useState(0);
    const [balance, setBalance] = useState(0);
    const [bal, setBal] = useState(0);
    const [balances, setBalances] = useState({});
    const [lastBalance, setLastBalance] = useState(0);

    const [rows, setRows] = useState([{ RawItCode: 0, OpBal: 0, BatchNo: '', Qty: 0.0, Weight: 0, Narration: '' }]);
    const [DeptCode, setDeptCode] = useState('');
    const [UserID, setUserID] = useState('');
    const [units, setUnits] = useState([]);
    const [editFormulaNo, setEditFormulaNo] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const location = useLocation();
    const flag = new URLSearchParams(location.search).get('flag');
    const title = new URLSearchParams(location.search).get('title');

    const [deleteEntryNo, setDeleteEntryNo] = useState(null);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [formMode, setFormMode] = useState('edit');
    const [editCasteId, setEditCasteCode] = useState(null);
    const [showGrid, setShowGrid] = useState(true);
    const [filteredRows, setFilteredRows] = useState([]);
    const [savedData, setSavedData] = useState([]);
    const [ProductMasterEntries, setProductMasterEntries] = useState([]);
    const [ProductFormulaMaster, setProductFormulaMaster] = useState([]);
    const [ProductPlanEntries, setProductPlanEntries] = useState([]);
    const [EmployeeMasterEntries, setEmployeeMasterEntries] = useState([]);
    const [settingMasterEntries, setSettingMasterEntries] = useState([]);

    const [itemMasterEntries, setItemMasterEntries] = useState([]);
    const [calculate, setCalculate] = useState(false);
    const [originalRows, setOriginalRows] = useState([]);
    const [targetRowIndex, setTargetRowIndex] = useState(null);


    useEffect(() => {
        fetchProductMaster();
        fetchItemMaster();
        fetchSettingMaster();
        //fetchProductFormula();
        fetchEmpMaster();
        fetchReportData2();
    }, []);

    useEffect(() => {
        fetchProductPlan();
        fetchProductFormula();
    }, []);

    const handlePerQtyChange = (e) => {
        setPerQty(e.target.value); // Update PerQty state
    };

    const handlePerQtyKeyDown = (e) => {
        if (e.key === 'Enter') {
            setCalculate(true); // Set calculate flag to true on Enter
        }
    };

    useEffect(() => {
        if (flag === 'PROD' && calculate) {
            const newPerQty = Number(PerQty);

            if (!isNaN(newPerQty) && newPerQty > 0) {
                const ratio = newPerQty / FormPerQty;

                // Calculate new Qty using the original quantities from the initial rows
                const updatedRows = originalRows.map((row) => ({
                    ...row,
                    Qty: (row.Qty * ratio).toFixed(2),
                    Weight: (row.Qty * ratio).toFixed(2),
                }));

                setRows(updatedRows);
            } else {
                setRows(originalRows);
            }
            setCalculate(false);
        }
    }, [calculate, PerQty, FormPerQty, originalRows]); // Include originalRows in dependencies


    useEffect(() => {
        if (flag === 'PRODPL' && calculate) {
            const newPerQty = Number(PerQty);
            //console.log(newPerQty);

            if (!isNaN(newPerQty) && newPerQty > 0) {
                const ratio = newPerQty / FormPerQty;

                const updatedRows = originalRows.map(row => ({
                    ...row,
                    Qty: (row.Qty * ratio).toFixed(2),
                    Weight: (row.Qty * ratio).toFixed(2),
                }));

                setRows(updatedRows);
            } else {
                setRows(originalRows);
            }
            setCalculate(false);
        }
    }, [calculate, PerQty, FormPerQty, originalRows]);


    const fetchProductMaster = async () => {
        try {
            const response = await axios.get(`https://www.wingap.net.in/api/processentry/${flag}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`);
            setProductMasterEntries(response.data);
            const maxEntryNo = calculateMaxEntryNo(response.data);
            const nextEntryNo = maxEntryNo + 1;
            setEntryNo(nextEntryNo);
            //console.log(response.data);
        } catch (error) {
            console.log('error:', error);
        }
    };

    const calculateMaxEntryNo = (entries) => {
        let maxEntryNo = 0;
        for (const entry of entries) {
            if (entry.EntryNo > maxEntryNo) {
                maxEntryNo = entry.EntryNo;
            }
        }
        return maxEntryNo;
    };

    const fetchProductPlan = async () => {
        try {
            const response = await axios.get(`https://www.wingap.net.in/api/processentry/PRODPL/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`);
            setProductPlanEntries(response.data);
            //console.log(response.data);
        } catch (error) {
            console.log('error:', error);
        }
    };

    const uniquePOData = Array.from(new Map(ProductPlanEntries.map(item => [item.EntryNo, item])).values());

    const fetchSettingMaster = async () => {
        try {
            const response = await axios.get('https://www.wingap.net.in/api/setting');
            setSettingMasterEntries(response.data);
            console.log(response.data);
        } catch (error) {
            console.log('error:', error);
        }
    };

    const isStockCheckEnabled = settingMasterEntries?.some(
        (s) =>
            s.SettingDesc1?.toLowerCase() === 'stockcheck' &&
            s.SettingValue1?.toLowerCase() === 'y'
    );


    const fetchEmpMaster = async () => {
        try {
            const response = await axios.get('https://www.wingap.net.in/api/employee');
            setEmployeeMasterEntries(response.data.sort((a, b) => a.EmpCode - b.EmpCode));
            //console.log(response)
        } catch (error) {
            console.log('error:', error);
        }
    };

    const fetchProductFormula = async () => {
        try {
            const response = await axios.get('https://www.wingap.net.in/api/prodForm');
            setProductFormulaMaster(response.data);
        } catch (error) {
            console.log('error:', error);
        }
    };

    const fetchItemMaster = async () => {
        try {
            const response = await axios.get("https://www.wingap.net.in/api/items-master");
            setItemMasterEntries(response.data.sort((a, b) => a.ItCode - b.ItCode));
        } catch (error) {
            console.log("error:", error);
        }
    };

    function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const addProduct = async () => {
        if ((!props.canAdd)) {
            const action = "Save";
            toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
            return;
        }
        try {
            const isQtyMismatch = rows.some((row) => {
                const batchList = row.BatchNo?.split(',') || [];
                const matchingSaved = savedData.filter(sd => sd.ItCode === row.RawItCode);

                for (const batch of batchList) {
                    const saved = matchingSaved.find(sd => sd.BatchNo === batch.trim());
                    if (!saved || Number(saved.Qty) !== Number(row.Qty)) {
                        return true; // mismatch found
                    }
                }

                return false; // no mismatch in this row
            });

            if (isQtyMismatch && flag === 'PROD') {
                showDuplicateEntryAlert();
                return;
            }

            const totalRowQty = rows.reduce((sum, row) => sum + Number(row.Qty || 0), 0);
            const totalSavedQty = savedData.reduce((sum, sd) => sum + Number(sd.Qty || 0), 0);
            const expectedTotal = Number(PerQty || 0) + Number(shortQty || 0) + Number(Loss || 0);

            if (totalRowQty !== expectedTotal || totalSavedQty !== expectedTotal && flag === 'PROD') {
                toast.warning(`Total Qty (${totalRowQty}/${totalSavedQty}) must equal ProdQty + Depouching (${expectedTotal})`, {
                    autoClose: 1100,
                });
                return;
            }

            const productData = {
                Flag: flag,
                EntryNo: Number(EntryNo),
                TrDate: TrDate,
                FinishedItCode: Number(FinishedItCode),
                PerQty: Number(PerQty),
                ShortQty: Number(shortQty),
                Loss: Number(Loss),
                // Rate: Rate,
                // Amount: Amount,
                BatchNo: BatchNo,
                Narration,
                EmpCode: EmpCode,
                ProdPlanNo: ProdPlanNo,
                items: rows,
                BatchQty: savedData,
                UserID: props.name,
                HeatNo: 5,
                DeptCode: props.selectedDept,
                YearCode: props.selectedYear,
                CompCode: props.selectedCompany,
            };
            await axios.post(`https://www.wingap.net.in/api/prodEntry/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`, productData);
            toast.success('Entry Added Successfully....', { autoClose: 650 });
            setPerQty(0.0);
            setShortQty(0.0);
            setNarration('');
            setFinishedItCode(0);
            setTrDate(getCurrentDate());
            setRate('');
            setAmount('');
            setProdPlanNo(0);
            setEmpCode('');
            setBal('');
            setBatchNo('');
            setRows([{ RawItCode: 0, BatchNo: '', OpBal: 0, Qty: 0.0, Weight: 0, Rate1: 0, Amount1: 0, Narration: '' }]);
            fetchProductMaster();
        } catch (error) {
            console.log('Error:', error);
        }
    };


    const updateProduct = async () => {
        if ((!props.canEdit)) {
            const action = "Update";
            toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
            return;
        }
        try {
            const updatedProductData = {
                TrDate: TrDate,
                FinishedItCode: Number(FinishedItCode),
                PerQty: Number(PerQty),
                ShortQty: Number(shortQty),
                Rate: Rate,
                Amount: Amount,
                BatchNo: BatchNo,
                Narration,
                ProdPlanNo: ProdPlanNo,
                EmpCode: EmpCode,
                items: rows,
                BatchQty: filteredRows,
                UserID: props.name,
                HeatNo: 5,
                DeptCode: props.selectedDept,
                YearCode: props.selectedYear,
                CompCode: props.selectedCompany,
            };
            await axios.put(`https://www.wingap.net.in/api/prodEntry/${flag}/${EntryNo}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`, updatedProductData);
            toast.success('Entry Updated Successfully....', { autoClose: 650 });
            setFormMode('add');
            setPerQty(0.0);
            setShortQty(0.0);
            setNarration('');
            setFinishedItCode(0);
            setTrDate(getCurrentDate());
            setRate('');
            setAmount('');
            setBal('');
            setProdPlanNo(0);
            setEmpCode('');
            setBatchNo('');
            setFilteredRows([]);
            setRows([{ RawItCode: 0, BatchNo: '', OpBal: 0, Qty: 0.0, Weight: 0, Rate1: 0, Amount1: 0, Narration: '' }]);
            fetchProductMaster();
        } catch (error) {
            console.log('Error updating product:', error);
        }
    };

    const handleDeleteConfirmation = async () => {
        try {
            if (deleteEntryNo) {
                await deleteProduct(deleteEntryNo.entryNo, deleteEntryNo.flag);
                setOpenConfirmation(false);
            }
        } catch (error) {
            console.log('Error:', error);
        }
    };

    const deleteProduct = async (EntryNo, flag) => {
        if (!props.canDelete) {
            toast.error("You do not have permission to Delete.", { autoClose: 800 });
            return;
        }
        try {
            await axios.delete(`https://www.wingap.net.in/api/distinctprocess/${EntryNo}/${flag}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`, {
                headers: {
                    'username': props.name,
                },
            });
            fetchProductMaster();
        } catch (error) {
            console.log('Error:', error);
        }
    };

    const setEditForm = async (room) => {
        setFormMode('edit');
        setEntryNo(room.EntryNo);
        const formattedDate = new Date(room.TrDate).toISOString().split("T")[0];
        setTrDate(formattedDate);
        setFinishedItCode(room.ItCode);
        setPerQty(room.PerQty);
        setShortQty(room.ShortQty);
        setNarration(room.Remark1);
        setBatchNo(room.ProdBatchNo);
        setRate(room.Rate);
        setAmount(room.Amount);
        setEmpCode(room.EmpCode);
        setProdPlanNo(room.ProdPlanEntryNo);
        setUserID(room.UserID);
        const finishedEntry = ProductFormulaMaster.find(entry => entry.FinishedItCode == room.ItCode);
        if (finishedEntry) {
            setFormPerQty(finishedEntry.PerQty);
        } else {
            setFormPerQty(0);
        }
        await handleEditBatchQty(formattedDate, room.EntryNo);

        const filteredEntries = ProductMasterEntries.filter(entry => entry.EntryNo == room.EntryNo);

        const newRows = filteredEntries.map(filteredEntry => {
            const item = itemMasterEntries.find(item => item.ItCode == filteredEntry.RawItCode);
            return {
                RawItCode: item ? item.ItCode : '',
                BatchNo: filteredEntry.BatchNo,
                Qty: filteredEntry.Qty,
                Weight: filteredEntry.Weight,
                Rate1: filteredEntry.Rate1,
                Amount1: filteredEntry.Amount1
            };
        });

        setRows(newRows);
        setShowGrid(false);
    };

    const handleSaveProduct = async () => {
        if (formMode === 'add') {
            await addProduct();
        } else if (formMode === 'edit') {
            await updateProduct();
        }
    };

    /* const handleFinishedItCodeChange = async (newValue) => {
        if (newValue) {
            const isFinishedItCodeValid = ProductFormulaMaster.some(entry => entry.FinishedItCode == newValue.ItCode);
            if (isFinishedItCodeValid) {
                setFinishedItCode(newValue.ItCode);

                const filteredEntries = ProductFormulaMaster.filter(entry => entry.FinishedItCode == newValue.ItCode);

                const newRows = filteredEntries.map(filteredEntry => {
                    const item = itemMasterEntries.find(item => item.ItCode === filteredEntry.RawItCode);
                    const lastBalance = await fetchReportData2(getCurrentDate(), getCurrentDate(), item);

                    return {
                        RawItCode: item ? item.ItCode : 0,
                        OpBal: lastBalance,
                        Qty: filteredEntry.Qty,
                        Weight: filteredEntry.Weight,
                    };
                });
                setRows(newRows);
                setOriginalRows(newRows);
                if (filteredEntries.length > 0) {
                    setFormPerQty(filteredEntries[0].PerQty);
                } else {
                    setFormPerQty(0);
                    fetchProductMaster();
                }
            } else {
                setFormMode('add');
                setFinishedItCode(newValue.ItCode);
                setRows([]);
                setFormPerQty(0);
                fetchProductMaster();
            }
        } else {
            setFormMode('add');
            setFinishedItCode('');
            setRows([]);
            setFormPerQty(0);
        }
    }; */

    const handleFinishedItCodeChange = async (newValue) => {
        if (newValue) {
            const lastBalance = newValue ? await fetchReportData2(getCurrentDate(), getCurrentDate(), newValue.ItCode) : 0;
            // console.log("Fetched lastBalance for FinishedItCode:", lastBalance);
            setBal(lastBalance);
            const isFinishedItCodeValid = ProductFormulaMaster.some(entry => entry.FinishedItCode == newValue.ItCode);
            if (isFinishedItCodeValid) {
                setFinishedItCode(newValue.ItCode);

                // Filter entries based on the FinishedItCode
                const filteredEntries = ProductFormulaMaster.filter(entry => entry.FinishedItCode == newValue.ItCode);

                // Fetch additional data for each filtered entry
                const newRows = await Promise.all(
                    filteredEntries.map(async (filteredEntry) => {
                        const item = itemMasterEntries.find(item => item.ItCode === filteredEntry.RawItCode);
                        const itemBalance = item ? await fetchReportData2(getCurrentDate(), getCurrentDate(), item.ItCode) : 0;

                        return {
                            RawItCode: item ? item.ItCode : 0,
                            OpBal: (itemBalance).toFixed(2),
                            Qty: filteredEntry.Qty,
                            BatchNo: '',
                            Weight: filteredEntry.PerKG,
                        };
                    })
                );

                // Update rows and original rows state
                setRows(newRows);
                setOriginalRows(newRows);

                if (filteredEntries.length > 0) {
                    setFormPerQty(filteredEntries[0].PerQty);
                } else {
                    setFormPerQty(0);
                    fetchProductMaster();
                }
            } else {
                setFormMode('add');
                setFinishedItCode(newValue.ItCode);
                setRows([]);
                setFormPerQty(0);
                fetchProductMaster();
            }
        } else {
            setFormMode('add');
            setFinishedItCode('');
            setBal(0);
            setRows([]);
            setFormPerQty(0);
        }
    };


    const handleExitButtonClick = () => {
        navigate('/Dashboard');
    };

    const handleshowandhide = async () => {
        setFormMode('add');
        setShowGrid(!showGrid);
        setUnits(units);
        setFinishedItCode('');
        setPerQty(0);
        setShortQty(0);
        setNarration('');
        setTrDate(getCurrentDate());
        setBatchNo('');
        setEmpCode('');
        setBal(0);
        setProdPlanNo(0);
        setFormPerQty(0);
        setFilteredRows([]);
        setSavedData([]);
        setRows([{ RawItCode: 0, BatchNo: '', OpBal: 0, Qty: 0.0, Weight: 0, Rate1: 0, Amount1: 0, Narration: '' }]);
        fetchProductMaster();
    };

    const handleCancel = () => {
        setFormMode('add');
        setEditCasteCode('');
        setPerQty(0);
        setShortQty(0.0);
        setNarration('');
        setFormPerQty('');
        setRate('');
        setAmount('');
        setBatchNo('');
        setProdPlanNo('');
        setEmpCode('');
        setRows([{ RawItCode: 0, BatchNo: '', OpBal: 0, Qty: 0.0, Weight: 0, Rate1: 0, Amount1: 0, Narration: '' }]);
        setUserID('');
        fetchProductMaster();
    };

    const handleClearTemp = async () => {
        try {
            handleCancel();
            handleshowandhide();
        } catch (error) {
            console.log('Error:', error);
        }
    };

    const componentPDF = useRef();

    const generatePDF = useReactToPrint({
        content: () => componentPDF.current,
        documentTitle: "Caste Data",
        onAfterPrint: () => alert("Pdf downloaded"),
        pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }

        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
    });

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleRowChange = (index, field, value) => {
        const updatedRows = rows.map((row, i) => {
            if (i === index) {
                return { ...row, [field]: field === 'RawItCode' || field === 'Qty' ? Number(value) : value };
            }
            return row;
        });
        setRows(updatedRows);
    };

    const addRow = () => {
        setRows([...rows, { RawItCode: 0, BatchNo: '', OpBal: 0, Qty: 0.0, Weight: 0, Rate1: 0, Amount1: 0, Narration: '' }]);
    };

    const removeRow = (index) => {
        const newRows = rows.filter((_, i) => i !== index);
        setRows(newRows);
    };

    const fetchReportData2 = async (formattedDate1, currentDate, itCode) => {
        if (!formattedDate1 || !currentDate || !itCode) {
            console.error('Missing required parameters:', { formattedDate1, currentDate, itCode });
            return;
        }
        setLoading(true);
        try {
            const requestData = {
                startDate: formattedDate1,
                endDate: currentDate,
                itemCode: itCode,
                CompCode: props.selectedCompany
            };

            const opBalFromReport = (await handleStockReport(formattedDate1, itCode)) || 0;
            //console.log('Opening Balance:', opBalFromReport);

            const response = await axios.get(`https://www.wingap.net.in/api/stockLedgerr`, { params: requestData });
            //console.log('Original Data:', response.data, opBalFromReport, requestData);

            if (response.data.length === 0) {
                setOpbal('');
                setBalance('');
                return opBalFromReport;
            }

            let opbal = Number(opBalFromReport) || 0;
            let lastCurrentBalance = opbal;

            const data = response.data
                .sort((a, b) => {
                    const dateA = new Date(a.TrDate);
                    const dateB = new Date(b.TrDate);

                    if (dateA < dateB) return -1;
                    if (dateA > dateB) return 1;

                    if (a.EntryNo < b.EntryNo) return -1;
                    if (a.EntryNo > b.EntryNo) return 1;

                    return 0;
                })
                .map((rowData) => {
                    const InQty = rowData.InQty || 0;
                    const OutQty = rowData.OutQty || 0;

                    const currentBalance = opbal + InQty - OutQty;
                    lastCurrentBalance = currentBalance;
                    opbal = currentBalance;

                    return {
                        ...rowData,
                        BalQty: `${currentBalance}`,
                    };
                });

            //console.log(data);

            if (data.length > 0) {
                setOpbal(data[data.length - 1].Balance || '');
                setBalance(data[data.length - 1].BalQty || '');
            } else {
                setOpbal('');
                setBalance('');
            }

            setLastBalance(lastCurrentBalance);
            return lastCurrentBalance;
        } catch (error) {
            console.error('Error in fetchReportData2:', error);
            return 0;
        } finally {
            setLoading(false); // Stop loading
        }
    };

    const handleStockReport = async (date, itcode) => {
        setLoading(true);
        try {
            const response = await axios.get('https://www.wingap.net.in/api/stockkReport', {
                params: {
                    startDate: BeforeformatDate1(date),
                    ItCode: parseInt(itcode),
                    CompCode: props.selectedCompany
                }
            });

            const balanceData = response.data.find(item => item.ItCode == parseInt(itcode));
            const opBal = balanceData ? balanceData.BalQty : 0;
            //console.log(response.data, balanceData, opBal);

            const balancesByDate = { [date]: { opBal } };
            setBalances(balancesByDate);

            return opBal;
        } catch (error) {
            console.error('Error fetching balances:', error);
        } finally {
            setLoading(false); // Stop loading
        }
    };

    const BeforeformatDate1 = (dateString) => {
        const date = new Date(dateString);
        date.setDate(date.getDate() - 1);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleBatchQty = async (date, itcode) => {
        try {
            const response = await axios.get('https://www.wingap.net.in/api/batchQty', {
                params: {
                    startDate: date,
                    ItCode: parseInt(itcode),
                    CompCode: props.selectedCompany
                }
            });
            //console.log(response.data);

            const filteredData = response.data.filter(item => item.ItCode == parseInt(itcode));
            setFilteredRows(filteredData);
        } catch (error) {
            console.error('Error fetching balances:', error);
        }
    };

    /* const handleEditBatchQty = async (trdate, entryno, itcode) => {
        try {
            const response = await axios.get('https://www.wingap.net.in/api/subProcessEntry', {
                params: {
                    TrDate: trdate,
                    ItCode: parseInt(itcode),
                    EntryNo: parseInt(entryno)
                }
            });
            
            const filteredData = response.data.filter(item => item.ItCode == parseInt(itcode));
            setFilteredRows(filteredData);
        } catch (error) {
            console.error('Error fetching balances:', error);
        }
    }; */

    const handleEditBatchQty = async (trdate, entryno, itcode) => {
        try {
            const params = {
                TrDate: trdate,
                EntryNo: parseInt(entryno),
            };

            if (itcode) {
                params.ItCode = parseInt(itcode);
            }

            const response = await axios.get(`https://www.wingap.net.in/api/subProcessEntry/${flag}/${props.selectedDept}/${props.selectedYear}/${props.selectedCompany}`, {
                params: params
            });

            if (itcode) {
                const filteredData = response.data.filter(item => item.ItCode === parseInt(itcode));
                setFilteredRows(filteredData);
            } else {
                //console.log(response.data);
                setFilteredRows(response.data);
            }
        } catch (error) {
            console.error('Error fetching balances:', error);
        }
    };

    /* const handleBatchQtyChange = (index, newQty, targetRowIndex) => {
        newQty = parseFloat(newQty);
        if (isNaN(newQty)) return;

        const balQty = filteredRows[index]?.BalQty ?? 0;

        if (newQty > balQty) {
            toast.warning("Qty cannot be greater than Balance Qty", { autoClose: 900 });
            return;
        }
        if (newQty < 0) {
            toast.warning("Qty cannot be less than 0", { autoClose: 1000 });
            return;
        }

        const updatedFilteredRows = filteredRows.map((row, i) => {
            if (i === index) { // Check if this is the selected row
                return { ...row, Qty: newQty }; // Update the `Qty` field for this row
            }
            return row; // Return the other rows unchanged
        });
        const relatedBatchNos = updatedFilteredRows
            .filter(fRow => fRow.Qty !== null && fRow.Qty !== undefined)
            .map(fRow => fRow.BatchNo)
            .join(',');

        // Update only the specific row in `rows`
        const updatedRows = rows.map((row, i) => {
            if (i === targetRowIndex) {
                return { ...row, BatchNo: relatedBatchNos }; // Update BatchNo for the specific row
            }
            return row; // Return other rows unchanged
        });

        setFilteredRows(updatedFilteredRows);
        setRows(updatedRows)
    }; */

    const handleDeleteRow = (rowIndex) => {
        if (formMode === 'add') {
            setSavedData(prev => prev.filter((_, i) => i !== rowIndex));
        }
        setFilteredRows(prev => prev.filter((_, i) => i !== rowIndex));
    };

    const handleBatchQtyChange = (index, newQty, targetRowIndex) => {
        // Allow empty string (user clearing the field)
        if (newQty === "") {
            const updatedFilteredRows = filteredRows.map((row, i) => {
                if (i === index) {
                    return { ...row, Qty: null };
                }
                return row;
            });

            const relatedBatchNos = updatedFilteredRows
                .filter(fRow => fRow.Qty !== null && fRow.Qty !== undefined)
                .map(fRow => fRow.BatchNo)
                .join(',');

            const updatedRows = rows.map((row, i) => {
                if (i === targetRowIndex) {
                    return { ...row, BatchNo: relatedBatchNos };
                }
                return row;
            });

            setFilteredRows(updatedFilteredRows);
            setRows(updatedRows);
            return;
        }

        newQty = parseFloat(newQty);
        if (isNaN(newQty)) return;

        if (isStockCheckEnabled) {
            const balQty = filteredRows[index]?.BalQty ?? 0;

            if (newQty > balQty) {
                toast.warning("Qty cannot be greater than BalQty", { autoClose: 920 });
                return;
            }

            if (newQty < 0) {
                toast.warning("Qty cannot be less than 0", { autoClose: 920 });
                return;
            }
        }

        const updatedFilteredRows = filteredRows.map((row, i) => {
            if (i === index) {
                return { ...row, Qty: newQty };
            }
            return row;
        });

        const relatedBatchNos = updatedFilteredRows
            .filter(fRow => fRow.Qty !== null && fRow.Qty !== undefined)
            .map(fRow => fRow.BatchNo)
            .join(',');

        const updatedRows = rows.map((row, i) => {
            if (i === targetRowIndex) {
                return { ...row, BatchNo: relatedBatchNos };
            }
            return row;
        });

        setFilteredRows(updatedFilteredRows);
        setRows(updatedRows);
    };

    const handleSave = () => {
        if (filteredRows.length > 0) {
            setSavedData((prevData) => {
                const updatedData = [...prevData, ...filteredRows];
                return updatedData;
            });
            setFilteredRows([]); // Clear filteredRows after saving
            toast.success('Batch Qty Saved Successfully!', { autoClose: 760 });
        } else {
            toast.warning('No data to save!', { autoClose: 760 });
        }
    };

    const totalQty = rows.reduce((total, row) => total + (parseFloat(row.Qty) || 0), 0);
    const totalWeight = rows.reduce((total, row) => total + (parseFloat(row.Weight) || 0), 0);

    return (
        <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
            <ToastContainer />
            <LoadingOverlay loading={loading} />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
                <h1 style={{ fontSize: '24px', margin: 0 }}>
                    {showGrid ? title : `${formMode === 'add' ? 'ADD' : 'EDIT'} ${title}`}
                </h1>

                <div style={{ display: 'flex' }}>
                    {showGrid && (
                        <Button
                            variant="contained"
                            onClick={generatePDF}
                            sx={{ backgroundColor: "yellow", color: "black", marginLeft: "10px", '&:hover': { color: "white" } }}
                        >
                            Download PDF
                        </Button>
                    )}
                    {showGrid && (
                        <Button
                            variant="contained"
                            sx={{ backgroundColor: "yellow", color: "black", marginLeft: "10px", '&:hover': { color: "white" } }}
                        >
                            Export
                        </Button>
                    )}
                    <Grid item>
                        {showGrid && (<Button
                            variant="contained"
                            onClick={handleExitButtonClick}
                            sx={{ backgroundColor: "red", color: "white", marginLeft: '10px' }}
                        >
                            Exit
                        </Button>)}
                        {(props.canAdd === true) && (<Button
                            variant="contained"
                            className="view-button"
                            onClick={handleshowandhide}
                            sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginLeft: '10px' }}
                        >
                            {showGrid ? 'Add' : 'Back'}
                        </Button>)}
                    </Grid>
                </div>
            </div>

            {!showGrid && (
                <>
                    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '4px' }}>
                        <>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '20px', width: '100%', backgroundColor: '#DEDADA', borderRadius: '5px', color: '#333', padding: '5px', }}>
                                <div style={{ flex: 2 }}>
                                    <div style={{ display: 'flex', gap: '6px', marginBottom: '2px' }}>
                                        {(flag === 'PROD' || flag === 'PRODPL') && <div style={{ width: '80px' }}>
                                            <label htmlFor="EntryNo">EntryNo</label>
                                            <input
                                                type="number"
                                                value={EntryNo}
                                                placeholder="EntryNo"
                                                readOnly
                                                style={{ padding: '5px', width: '100%' }}
                                            />
                                        </div>}
                                        {(flag === 'PROD' || flag === 'PRODPL') && <div style={{ width: '110px' }}>
                                            <label htmlFor="TrDate">TrDate</label>
                                            <input
                                                type="date"
                                                value={TrDate}
                                                onChange={(e) => setTrDate(e.target.value)}
                                                placeholder="TrDate"
                                                style={{ padding: '5px', width: '100%' }}
                                            />
                                        </div>}
                                        {flag === 'PROD' && <div style={{ width: '110px' }}>
                                            <label htmlFor="ProdPlanNo">ProdPlan EntryNo</label>
                                            <select
                                                value={ProdPlanNo}
                                                onChange={async (e) => {
                                                    const selectedEntryNo = e.target.value;
                                                    setProdPlanNo(selectedEntryNo);

                                                    const allMatchingEntries = ProductPlanEntries.filter(
                                                        (entry) => entry.EntryNo == selectedEntryNo
                                                    );

                                                    if (allMatchingEntries.length > 0) {
                                                        setFinishedItCode(allMatchingEntries[0].ItCode);
                                                        setFormPerQty(allMatchingEntries[0].PerQty);
                                                        setNarration(allMatchingEntries[0].Remark1);

                                                        const newRows = await Promise.all(
                                                            allMatchingEntries.map(async (filteredEntry) => {
                                                                const lastBalance = await fetchReportData2(
                                                                    getCurrentDate(),
                                                                    getCurrentDate(),
                                                                    filteredEntry.RawItCode
                                                                );

                                                                return {
                                                                    RawItCode: filteredEntry.RawItCode || '',
                                                                    OpBal: (lastBalance).toFixed(2) || 0,
                                                                    Qty: filteredEntry.Qty || '',
                                                                    BatchNo: "",
                                                                    Weight: filteredEntry.Weight || '',
                                                                };
                                                            })
                                                        );

                                                        setRows(newRows);
                                                        setOriginalRows(newRows);
                                                    } else {
                                                        // Reset values if no matching entries found
                                                        setFinishedItCode(0);
                                                        setFormPerQty(0);
                                                        setNarration('');
                                                        setRows([]);
                                                    }
                                                }}
                                                style={{ padding: '5px', width: '100%' }}
                                            >
                                                <option value="">Plan EntryNo</option>
                                                {uniquePOData.map((group) => (
                                                    <option key={group.EntryNo} value={group.EntryNo}>
                                                        {group.EntryNo}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>}
                                        {/* {(flag === 'PROD' || flag === 'PRODPL') && <div>
                                            <label htmlFor="FinishedItCode">FinishedItCode</label>
                                            <Autocomplete
                                                options={itemMasterEntries}
                                                getOptionLabel={(option) => option.ItName || ''}
                                                value={itemMasterEntries.find((item) => item.ItCode == FinishedItCode) || null}
                                                onChange={(event, newValue) => handleFinishedItCodeChange(newValue)}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        variant="outlined"
                                                        placeholder="FinishedItCode"
                                                        sx={{
                                                            marginBottom: '5px',
                                                            width: '260px',
                                                            '& .MuiInputBase-input': {
                                                                color: 'black',
                                                                padding: '1px',
                                                                height: '1px'
                                                            },
                                                            '& .MuiInputLabel-root': {
                                                                color: 'black',
                                                            },
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                borderColor: 'black',
                                                            },
                                                            '& .MuiSvgIcon-root': {
                                                                color: 'black',
                                                            },
                                                            backgroundColor: 'white'
                                                        }}
                                                    />
                                                )}
                                                sx={{ width: '260px' }}
                                                isOptionEqualToValue={(option, value) => option.ItCode === value.ItCode}
                                            />
                                        </div>} */}
                                        {(flag === 'PROD' || flag === 'PRODPL') && <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', marginLeft: '2px' }}>
                                            <label htmlFor="FinishedItCode">Finished Item (Loose)</label>
                                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
                                                <TextField
                                                    placeholder="Enter ItCode"
                                                    value={FinishedItCode || ''}
                                                    onChange={(e) => {
                                                        const newCode = e.target.value;
                                                        setFinishedItCode(newCode);

                                                        const matchedItem = itemMasterEntries.find(item => item.ItCode == newCode);
                                                        if (matchedItem) {
                                                            handleFinishedItCodeChange(matchedItem); // Update with the full item object
                                                        }
                                                    }}
                                                    sx={{
                                                        marginBottom: '5px',
                                                        marginRight: '4px',
                                                        width: '72px',
                                                        '& .MuiInputBase-input': {
                                                            color: 'black',
                                                            padding: '6px',
                                                        },
                                                        '& .MuiOutlinedInput-notchedOutline': {
                                                            borderColor: 'black',
                                                        },
                                                        backgroundColor: 'white'
                                                    }}
                                                />
                                                <Autocomplete
                                                    options={itemMasterEntries}
                                                    getOptionLabel={(option) => option.PartNo ? `${option.PartNo} - ${option.ItName}` : option.ItName}
                                                    value={itemMasterEntries.find((item) => item.ItCode == FinishedItCode) || null}
                                                    onChange={(event, newValue) => handleFinishedItCodeChange(newValue)}
                                                    filterOptions={(options, { inputValue }) => {
                                                        const lowerInput = inputValue.toLowerCase();
                                                        if (!lowerInput) return options; // Show all options when input is empty

                                                        return options.filter(
                                                            option =>
                                                                (option.PartNo && option.PartNo.toLowerCase().includes(lowerInput)) ||
                                                                (option.ItName && option.ItName.toLowerCase().includes(lowerInput))
                                                        );
                                                    }}
                                                    renderOption={(props, option) => (
                                                            <li {...props} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <span style={{ textAlign: 'left' }}>{option.PartNo}</span>
                                                                <span style={{ textAlign: 'right', fontWeight:600 }}>{option.ItName}</span>
                                                            </li>
                                                        )}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder="Code / ItName"
                                                            sx={{
                                                                marginBottom: '5px',
                                                                width: '292px',
                                                                '& .MuiInputBase-input': { color: 'black', padding: '1px', height: '1px' },
                                                                '& .MuiOutlinedInput-notchedOutline': { borderColor: 'black' },
                                                                backgroundColor: 'white'
                                                            }}
                                                        />
                                                    )}
                                                    sx={{ width: '292px' }}
                                                    isOptionEqualToValue={(option, value) => option.ItCode === value.ItCode}
                                                />
                                            </div>
                                        </div>}
                                        <div style={{ width: '80px' }}>
                                            <label htmlFor="Balance">Balance</label>
                                            <input
                                                type="number"
                                                value={bal}
                                                readOnly
                                                placeholder="Balance"
                                                style={{ padding: '4px', width: '100%', backgroundColor: '#4caf50', fontWeight: 'bold', textAlign: 'right' }}
                                            />
                                        </div>
                                        {(flag === 'PROD' || flag === 'PRODPL') && <div style={{ width: '80px' }}>
                                            <label htmlFor="FormPerQty">{flag === 'PROD' ? 'ProdPlan Qty' : 'Formula Qty'}</label>
                                            <input
                                                type="number"
                                                value={FormPerQty}
                                                readOnly
                                                placeholder="Formula Qty"
                                                style={{ padding: '4px', width: '100%', backgroundColor: 'darkkhaki', fontWeight: 'bold', textAlign: 'right' }}
                                            />
                                        </div>}
                                    </div>

                                    <div style={{ display: 'flex', gap: '6px', marginBottom: '2px' }}>
                                        {(flag === 'PROD' || flag === 'PRODPL') && <div>
                                            <label htmlFor="PerQty">Prod Qty<br /></label>
                                            <input
                                                type="number"
                                                value={PerQty}
                                                onChange={handlePerQtyChange}
                                                onKeyDown={handlePerQtyKeyDown}
                                                placeholder="Production Qty"
                                                style={{ padding: '5px', width: '86px', textAlign: 'right' }}
                                            />
                                        </div>}
                                        {(flag === 'PROD') && <div>
                                            <label htmlFor="Depouching">Depouching<br /></label>
                                            <input
                                                type="number"
                                                value={shortQty}
                                                onChange={(e) => setShortQty(e.target.value)}
                                                placeholder="Depouching"
                                                style={{ padding: '5px', width: '86px', textAlign: 'right' }}
                                            />
                                        </div>}
                                        {/* {(flag === 'PROD') && <div>
                                            <label htmlFor="Rate">Rate<br /></label>
                                            <input
                                                type="number"
                                                value={Rate}
                                                onChange={(e) => setRate(e.target.value)}
                                                placeholder="Rate"
                                                style={{ padding: '5px', width: '80px', textAlign: 'right' }}
                                            />
                                        </div>}
                                        {(flag === 'PROD') && <div>
                                            <label htmlFor="Amount">Amount<br /></label>
                                            <input
                                                type="number"
                                                value={Amount}
                                                onChange={(e) => setAmount(e.target.value)}
                                                placeholder="Amount"
                                                style={{ padding: '5px', width: '80px', textAlign: 'right' }}
                                            />
                                        </div>} */}
                                        {(flag === 'PROD') && <div>
                                            <label htmlFor="Loss">Loss<br /></label>
                                            <input
                                                type="number"
                                                value={Loss}
                                                onChange={(e) => setLoss(e.target.value)}
                                                placeholder="Rate"
                                                style={{ padding: '5px', width: '80px', textAlign: 'right' }}
                                            />
                                        </div>}
                                        {(flag === 'PROD') && <div>
                                            <label htmlFor="BatchNo">BatchNo<br /></label>
                                            <input
                                                type="text"
                                                id="BatchNo"
                                                value={BatchNo}
                                                onChange={(e) => setBatchNo(e.target.value)}
                                                placeholder="BatchNo"
                                                style={{ width: '120px', padding: '5px' }}
                                            />
                                        </div>}
                                        {/* 
                                        {(flag === 'PROD') && <div>
                                            <label htmlFor="EmpCode">EmpCode<br /></label>
                                            <select
                                                value={EmpCode}
                                                onChange={(e) => {
                                                    const selectedGroupName = e.target.value;
                                                    setEmpCode(selectedGroupName);
                                                    const selectedGroup = EmployeeMasterEntries.find(group => group.EmpCode == selectedGroupName);
                                                    if (selectedGroup) {
                                                        setEmpCode(selectedGroup.EmpCode);
                                                    }
                                                }}
                                                style={{ padding: '5px', width: '180px' }}
                                            >
                                                {EmployeeMasterEntries.map((group) => (
                                                    <option key={group.EmpCode} value={group.EmpCode}>{group.EmpName}</option>
                                                ))}
                                            </select>
                                        </div>} */}
                                        {(flag === 'PROD' || flag === 'PRODPL') && <div>
                                            <label htmlFor="Narration">Narration<br /></label>
                                            <input
                                                type="text"
                                                id="Narration"
                                                placeholder="Narration"
                                                style={{ width: '280px', padding: '5px' }}
                                            />
                                        </div>}
                                    </div>
                                </div>

                                <div style={{ flex: 1.1 }}>
                                    {flag === 'PROD' &&
                                        <div
                                            style={{
                                                backgroundColor: 'white',
                                                maxHeight: '140px',
                                                overflowY: 'auto',
                                            }}
                                        >
                                            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                                <thead style={{ backgroundColor: '#DEDADA', position: 'sticky', top: 0, zIndex: 10 }}>
                                                    <tr>
                                                        <th style={{ border: '1px solid #333', padding: '2px' }}>ItemName</th>
                                                        <th style={{ border: '1px solid #333', padding: '2px' }}>BatchNo</th>
                                                        <th style={{ border: '1px solid #333', padding: '2px' }}>BalQty</th>
                                                        <th style={{ border: '1px solid #333', padding: '2px' }}>Qty</th>
                                                        <th style={{ border: '1px solid #333', padding: '2px' }}></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredRows.map((row, index) => {
                                                        const selectedGroup = itemMasterEntries.find(group => group.ItCode == row.ItCode)?.ItName;
                                                        return (
                                                            <tr key={index}>
                                                                <td style={{ padding: '1px', fontSize: '9px', fontWeight: 'bold', width: '100px', border: '1px solid #333', textAlign: 'center' }}>
                                                                    {selectedGroup ? selectedGroup : ''}
                                                                </td>
                                                                <td style={{ padding: '1px', width: '60px', fontWeight: 'bold', border: '1px solid #333', textAlign: 'center' }}>
                                                                    {row.BatchNo || 'N/A'}
                                                                </td>
                                                                <td style={{ padding: '1px', width: '60px', fontWeight: 'bold', border: '1px solid #333', textAlign: 'right' }}>
                                                                    {row.BalQty ? row.BalQty.toFixed(2) : 0}
                                                                </td>
                                                                <td style={{ padding: '0', width: '60px', fontWeight: 'bold', border: '1px solid #333', textAlign: 'right' }}>
                                                                    <input
                                                                        type="number"
                                                                        max={row.BalQty}
                                                                        value={row.Qty === null || row.Qty === undefined ? '' : row.Qty}
                                                                        style={{ width: '100%', textAlign: 'right', border: 'none' }}
                                                                        onChange={(e) => handleBatchQtyChange(index, e.target.value, targetRowIndex)}
                                                                    />
                                                                </td>
                                                                <td style={{ textAlign: 'center', border: '1px solid #333' }}>
                                                                    <button
                                                                        onClick={() => handleDeleteRow(index)}
                                                                        style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                                                                    >
                                                                        <DeleteIcon style={{ color: 'red', fontSize: '18px' }} />
                                                                    </button>
                                                                </td>

                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                                <tfoot>
                                                    <tr style={{ backgroundColor: '#f1f1f1', fontWeight: 'bold' }}>
                                                        <td colSpan={3} style={{ textAlign: 'right', padding: '4px', border: '1px solid #333' }}>Total</td>
                                                        <td style={{ textAlign: 'right', padding: '4px', border: '1px solid #333' }}>
                                                            {formMode === 'add' ? savedData.reduce((sum, row) => sum + Number(row.Qty || 0), 0).toFixed(2)
                                                                : filteredRows.reduce((sum, row) => sum + Number(row.Qty || 0), 0).toFixed(2)}
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>}
                                    {(formMode == 'add' && flag == 'PROD') && <div style={{ marginTop: '10px', float: 'right' }}>
                                        <button onClick={handleSave} style={{ padding: '10px', backgroundColor: '#4caf50', color: 'white', border: 'none' }}>
                                            Save
                                        </button>
                                    </div>}
                                </div>
                            </div>
                        </>

                        <div style={{
                            overflow: 'auto',
                            maxHeight: '460px',
                            width: '100%',
                            margin: '2px auto',
                            marginBottom: '1px',
                            padding: '2px',
                            borderRadius: '5px',
                            /* backgroundColor: '#DEDADA', */
                        }}>
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                border: '1px solid white',
                                tableLayout: 'fixed'
                            }}>
                                <thead style={{ backgroundColor: '#1168AA', color: 'white', position: 'sticky', top: 0, zIndex: 10 }}>
                                    <tr>
                                        <th style={{ width: '45px', border: '1px solid white', padding: '6px' }}>SrNo.</th>
                                        {(flag === 'PROD' || flag === 'PRODPL') && <th style={{ width: '60px', border: '1px solid white', padding: '6px' }}>ItCode</th>}
                                        {(flag === 'PROD' || flag === 'PRODPL') && <th style={{ width: '250px', border: '1px solid white', padding: '6px' }}>ItName</th>}
                                        {(flag === 'PROD') && <th style={{ width: '68px', border: '1px solid white', padding: '6px' }}>Balance</th>}
                                        {(flag === 'PROD') && <th style={{ width: '120px', border: '1px solid white', padding: '6px' }}>BatchNo</th>}
                                        {(flag === 'PROD' || flag === 'PRODPL') && <th style={{ width: '120px', border: '1px solid white', padding: '6px' }}>Qty</th>}
                                        {(flag === 'PROD' || flag === 'PRODPL') && <th style={{ width: '120px', border: '1px solid white', padding: '6px' }}>Weight</th>}
                                        {/* {(flag === 'PROD') && <th style={{ width: '120px', border: '1px solid white', padding: '6px' }}>Rate</th>}
                                        {(flag === 'PROD') && <th style={{ width: '120px', border: '1px solid white', padding: '6px' }}>Amount</th>} */}
                                        {(flag === 'PROD') && <th style={{ width: '170px', border: '1px solid white', padding: '6px' }}>Narration</th>}
                                        {(flag === 'PROD') && <th style={{ width: '80px', border: '1px solid white', padding: '6px' }}>Action</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, index) => (
                                        <tr key={index}>
                                            <td style={{ width: '46px', padding: '2px', border: '1px solid #333', textAlign: 'center' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '4px', width: '100%' }}>
                                                    <span style={{ fontSize: '0.8rem' }}>{index + 1}</span>
                                                    <IconButton
                                                        onClick={() => removeRow(index)}
                                                        aria-label="delete"
                                                        sx={{ padding: '4px' }}
                                                    >
                                                        <DeleteIcon sx={{ color: 'red', fontSize: '1.2rem' }} />
                                                    </IconButton>
                                                </div>
                                            </td>
                                            {(flag === 'PROD' || flag === 'PRODPL') && (
                                                <td style={{ border: '1px solid #333', padding: '2px', width: '250px' }}>
                                                    <TextField
                                                        value={row.RawItCode || ''}
                                                        onChange={(e) => {
                                                            const inputCode = e.target.value;
                                                            const matchedItem = itemMasterEntries.find(item => item.ItCode == inputCode);

                                                            const updatedRows = [...rows];
                                                            updatedRows[index] = {
                                                                ...updatedRows[index],
                                                                RawItCode: inputCode,
                                                            };

                                                            // If matched, update the weight & OpBal
                                                            if (matchedItem) {

                                                                fetchReportData2(getCurrentDate(), getCurrentDate(), matchedItem.ItCode).then((lastBalance) => {
                                                                    updatedRows[index].OpBal = lastBalance;
                                                                    setRows(updatedRows);
                                                                });
                                                            } else {
                                                                // If not matched, clear OpBal and Weight
                                                                updatedRows[index].OpBal = '';
                                                                setRows(updatedRows);
                                                            }
                                                        }}
                                                        fullWidth
                                                        placeholder="RawItCode"
                                                        sx={{
                                                            marginBottom: '4px',
                                                            '& .MuiInputBase-input': {
                                                                color: 'black',
                                                                padding: '1px',
                                                            },
                                                            '& .MuiInputLabel-root': {
                                                                color: 'black',
                                                            },
                                                            '& .MuiOutlinedInput-notchedOutline': {
                                                                border: 'none',
                                                            },
                                                            '& .MuiSvgIcon-root': {
                                                                color: 'black',
                                                            },
                                                            backgroundColor: 'white',
                                                        }}
                                                    />
                                                </td>
                                            )}
                                            {(flag === 'PROD' || flag === 'PRODPL') && (
                                                <td style={{ border: '1px solid #333', padding: '2px', width: '250px' }}>
                                                    <Autocomplete
                                                        value={itemMasterEntries.find((item) => item.ItCode === Number(row.RawItCode)) || null}
                                                        options={itemMasterEntries}
                                                        getOptionLabel={(option) => option.PartNo ? `${option.PartNo} - ${option.ItName}` : option.ItName}
                                                        onChange={async (event, newValue) => {
                                                            if (newValue) {
                                                                const selectedItCode = newValue.ItCode;

                                                                try {
                                                                    const lastBalance = await fetchReportData2(getCurrentDate(), getCurrentDate(), selectedItCode);

                                                                    const updatedRows = [...rows];
                                                                    updatedRows[index] = {
                                                                        ...updatedRows[index],
                                                                        RawItCode: selectedItCode,
                                                                        OpBal: (lastBalance).toFixed(2),
                                                                    };
                                                                    setRows(updatedRows);
                                                                } catch (error) {
                                                                    console.error('Error fetching last balance:', error);
                                                                }
                                                            } else {
                                                                const updatedRows = [...rows];
                                                                updatedRows[index] = {
                                                                    ...updatedRows[index],
                                                                    RawItCode: '',
                                                                    OpBal: '',
                                                                };
                                                                setRows(updatedRows);
                                                            }
                                                        }}
                                                        renderOption={(props, option) => (
                                                            <li {...props} style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                <span style={{ textAlign: 'left' }}>{option.PartNo}</span>
                                                                <span style={{ textAlign: 'right' }}>{option.ItName}</span>
                                                            </li>
                                                        )}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                variant="outlined"
                                                                placeholder="RawItemName"
                                                                sx={{
                                                                    marginBottom: '0px',
                                                                    width: '100%',
                                                                    '& .MuiInputBase-input': {
                                                                        color: 'black',
                                                                        padding: '1px',
                                                                        height: '1px'
                                                                    },
                                                                    '& .MuiInputLabel-root': {
                                                                        color: 'black',
                                                                    },
                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                        border: 'none',
                                                                    },
                                                                    '& .MuiSvgIcon-root': {
                                                                        color: 'black',
                                                                    },
                                                                    backgroundColor: 'white',
                                                                }}
                                                            />
                                                        )}
                                                        sx={{ width: '100%' }}
                                                    />
                                                </td>
                                            )}

                                            {(flag === 'PROD') && <td style={{ width: '60px', border: '1px solid #333', padding: '2px' }}>
                                                <input
                                                    type="text"
                                                    value={row.OpBal}
                                                    placeholder="Balance"
                                                    style={{ padding: '5px', border: 'none', backgroundColor: '#4caf50', fontWeight: 'bold', width: '100%', textAlign: 'right' }}
                                                />
                                            </td>}
                                            {(flag === 'PROD') && <td style={{ width: '120px', border: '1px solid #333', padding: '2px' }}>
                                                <input
                                                    type="text"
                                                    value={row.BatchNo}
                                                    onChange={(e) => handleRowChange(index, 'BatchNo', e.target.value)}
                                                    placeholder="BatchNo"
                                                    style={{ padding: '5px', border: 'none', width: '100%', textAlign: 'right' }}
                                                />
                                            </td>}
                                            {(flag === 'PROD' || flag === 'PRODPL') && <td style={{ width: '120px', border: '1px solid #333', padding: '2px' }}>
                                                <input
                                                    type="number"
                                                    value={row.Qty}
                                                    onChange={(e) => {
                                                        const newQty = parseFloat(e.target.value);
                                                        const currentOpBal = parseFloat(row.OpBal);

                                                        if (isStockCheckEnabled) {
                                                            if (!isNaN(newQty) && !isNaN(currentOpBal)) {
                                                                if (newQty > currentOpBal) {
                                                                    toast.warning(`Qty (${newQty}) is greater than Balance (${currentOpBal})`, { autoClose: 1000 });

                                                                    const updatedRows = [...rows];
                                                                    updatedRows[index] = {
                                                                        ...updatedRows[index],
                                                                        Qty: '',
                                                                    };
                                                                    setRows(updatedRows);
                                                                    return;
                                                                }
                                                            }
                                                        }
                                                        handleRowChange(index, 'Qty', e.target.value);
                                                    }}
                                                    placeholder="Qty"
                                                    style={{ padding: '5px', border: 'none', width: '100%', textAlign: 'right' }}
                                                />
                                            </td>}
                                            {(flag === 'PROD' || flag === 'PRODPL') && <td style={{ width: '120px', border: '1px solid #333', padding: '2px' }}>
                                                <input
                                                    type="number"
                                                    value={row.Weight}
                                                    onChange={(e) => handleRowChange(index, 'Weight', e.target.value)}
                                                    placeholder="Weight"
                                                    style={{ padding: '5px', border: 'none', width: '100%', textAlign: 'right' }}
                                                />
                                            </td>}
                                            {/* {(flag === 'PROD') && <td style={{ width: '120px', border: '1px solid #333', padding: '2px' }}>
                                                <input
                                                    type="number"
                                                    value={row.Rate1}
                                                    onChange={(e) => handleRowChange(index, 'Rate1', e.target.value)}
                                                    placeholder="Rate"
                                                    style={{ padding: '5px', border: 'none', width: '100%', textAlign: 'right' }}
                                                />
                                            </td>}
                                            {(flag === 'PROD') && <td style={{ width: '120px', border: '1px solid #333', padding: '2px' }}>
                                                <input
                                                    type="number"
                                                    value={row.Amount1}
                                                    onChange={(e) => handleRowChange(index, 'Amount1', e.target.value)}
                                                    placeholder="Amount"
                                                    style={{ padding: '5px', border: 'none', width: '100%', textAlign: 'right' }}
                                                />
                                            </td>} */}
                                            {(flag === 'PROD') && <td style={{ width: '180px', border: '1px solid #333', padding: '2px' }}>
                                                <input
                                                    type="text"
                                                    value={row.Narration}
                                                    onChange={(e) => handleRowChange(index, 'Narration', e.target.value)}
                                                    placeholder="Narration"
                                                    style={{ padding: '5px', border: 'none', width: '100%' }}
                                                />
                                            </td>}
                                            {(flag === 'PROD') && (
                                                <td style={{ width: '180px', border: '1px solid #333', padding: '2px', textAlign: 'center' }}>
                                                    <InfoIcon
                                                        style={{ cursor: 'pointer', color: '#007BFF', fontSize: '22px' }}
                                                        onClick={async () => {
                                                            const itCode = rows[index].RawItCode;
                                                            if (!itCode) {
                                                                toast.warning('RawItCode is empty', { autoClose: 760 });
                                                                return;
                                                            }

                                                            if (formMode === 'add') {
                                                                const savedEntry = savedData.filter(item => item.ItCode === parseInt(itCode));

                                                                if (savedEntry.length > 0) {
                                                                    setFilteredRows(savedEntry);
                                                                    //toast.info('Displaying saved data for the selected ItCode.', { autoClose: 760 });
                                                                } else {
                                                                    await handleBatchQty(getCurrentDate(), itCode);
                                                                }
                                                            } else {
                                                                const trDate = TrDate;
                                                                const entryNo = EntryNo;
                                                                if (trDate && entryNo) {
                                                                    await handleEditBatchQty(trDate, entryNo, itCode);
                                                                } else {
                                                                    console.log('TrDate or EntryNo is missing');
                                                                }
                                                            }
                                                            setTargetRowIndex(index);
                                                        }}
                                                    />
                                                </td>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr style={{
                                        position: 'sticky',
                                        bottom: 0,
                                        zIndex: 10,
                                        backgroundColor: '#f1f1f1'
                                    }}>
                                        <td
                                            colSpan={(flag === 'PROD' ? 5 : 3)} // Adjust the colSpan based on the flag or condition
                                            style={{ border: '1px solid #333', padding: '6px', textAlign: 'center' }}
                                        >
                                            <strong>Total</strong>
                                        </td>
                                        <td style={{ border: '1px solid #333', padding: '6px', textAlign: 'right' }}>
                                            <strong>{totalQty.toFixed(2)}</strong>
                                        </td>
                                        <td style={{ border: '1px solid #333', padding: '6px', textAlign: 'right' }}>
                                            <strong>{totalWeight.toFixed(2)}</strong>
                                        </td>
                                        {flag === 'PROD' && (
                                            <td colSpan={2} style={{ border: '1px solid #333', padding: '6px' }}></td>
                                        )}
                                    </tr>

                                </tfoot>
                            </table>
                        </div>
                        <div style={{
                            overflow: 'auto',
                            width: '100%',
                            marginBottom: '2px',
                            borderRadius: '5px',
                        }}>
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                border: '1px solid white',
                                tableLayout: 'fixed', marginTop: '1px'
                            }}>
                                <tbody>
                                    <tr style={{
                                        position: 'sticky',
                                        bottom: 0,
                                        zIndex: 11,
                                        backgroundColor: '#f1f1f1'
                                    }}>
                                        <td colSpan={(flag === 'PROD' ? 9 : 5)} style={{ textAlign: "left", padding: "2px", border: "1px solid #333" }}>
                                            <button
                                                onClick={addRow}
                                                style={{
                                                    //backgroundColor: "white",
                                                    color: "black",
                                                    padding: "4px 12px",
                                                    border: "none",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "5px",
                                                }}
                                            >
                                                ➕ Add Row
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div style={{ backgroundColor: '#DEDADA' }}>
                        <button
                            onClick={handleSaveProduct}
                            style={{
                                padding: '10px 20px',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                marginBottom: '10px',
                                borderRadius: '5px'
                            }}
                        >
                            {formMode === 'add' ? 'Save' : 'Update'}
                        </button>
                        <button
                            className="view-button"
                            onClick={handleClearTemp}
                            style={{
                                padding: '10px 20px',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                backgroundColor: '#f44336',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                marginLeft: '10px',
                                marginBottom: '10px',
                                borderRadius: '5px'
                            }}
                        >
                            Exit
                        </button>
                    </div>
                </>
            )}
            {showGrid && (
                <div ref={componentPDF} style={{ width: '100%' }}>
                    <table
                        style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            border: '1px solid #ccc',
                        }}
                    >
                        <thead>
                            <tr style={{ background: '#f2f2f2', color: 'black' }}>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    SrNo.
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    EntryNo
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    TrDate
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    FinishedItCode
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    ProdQty
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                    className="print-hide"
                                >
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {ProductMasterEntries.reduce((accumulator, current) => {
                                const x = accumulator.find(item => item.EntryNo === current.EntryNo);
                                if (!x) {
                                    return accumulator.concat([current]);
                                } else {
                                    return accumulator;
                                }

                            }, []).sort((a, b) => {
                                const dateA = new Date(a.TrDate);
                                const dateB = new Date(b.TrDate);
                                if (dateA > dateB) return -1;
                                if (dateA < dateB) return 1;
                                if (a.EntryNo > b.EntryNo) return -1;
                                if (a.EntryNo < b.EntryNo) return 1;
                                return 0;
                            }).map((caste, index) => {
                                const selectedGroup = itemMasterEntries.find(group => group.ItCode == caste.ItCode);
                                return (
                                    <tr key={caste.EntryNo} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                                        <td style={{ padding: '6px', border: '1px solid #ccc', width: '10%' }}>{index + 1} </td>
                                        <td style={{ padding: '6px', border: '1px solid #ccc', width: '10%' }}>{caste.EntryNo} </td>
                                        <td style={{ padding: '6px', border: '1px solid #ccc', width: '10%' }}>{new Date(caste.TrDate).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</td>
                                        <td style={{ padding: '6px', border: '1px solid #ccc' }}>{selectedGroup ? `${selectedGroup.ItName}` : ''} </td>
                                        <td style={{ padding: '6px', border: '1px solid #ccc' }}>{caste.PerQty}</td>

                                        <td className="print-hide" style={{ width: '20%', border: '1px solid #ccc' }}>
                                            <button
                                            className='action-btn btn-edit'
                                                onClick={() => setEditForm(caste)}
                                            >
                                                Edit
                                            </button>
                                            <button
                                                className='action-btn btn-delete'
                                                //onClick={() => deleteProduct(caste.FormulaNo)}
                                                onClick={() => {
                                                    setDeleteEntryNo({ entryNo: caste.EntryNo, flag: caste.Flag });
                                                    setOpenConfirmation(true);
                                                }}
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
            {<Dialog
                open={openConfirmation}
                onClose={() => setOpenConfirmation(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"CONFIRM DELETE"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to DELETE this Entry ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                        Cancel
                    </Button>
                    <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>}
        </div>
    );
}
export default ProductionEntry;
